export const UPDATE_SUPPLIER_INVOICES_LIST = 'UPDATE_SUPPLIER_INVOICES_LIST'
export const LOAD_SUPPLIER_INVOICES_LIST = 'LOAD_SUPPLIER_INVOICES_LIST'
export const SELECT_FOR_APPROVE_PAYMENT = 'SELECT_FOR_APPROVE_PAYMENT'
export const UNSELECT_FOR_APPROVE_PAYMENT = 'UNSELECT_FOR_APPROVE_PAYMENT'
export const CHANGE_APPROVE_SELECTION_FOR_ALL = 'CHANGE_APPROVE_SELECTION_FOR_ALL'
